(function(){

    'use strict';

    /* =========================================================
       CONFIGURATION
       ========================================================= */
    var CONFIG = {
      WEB3FORMS_ACCESS_KEY: 'e73540c1-ca4a-45a0-8288-777e9cdc3a51',
      WEB3FORMS_ENDPOINT:   'https://api.web3forms.com/submit',
      CONTACT_EMAIL:        (window.PHENIX_SHOPIFY && window.PHENIX_SHOPIFY.shop_email) || 'contact@phenixpc.fr',   // pour le fallback mailto
      CALENDLY_URL:         'https://calendly.com/phenixpcgaming/30min',
      FETCH_TIMEOUT_MS:     25000,   // 25s (au lieu de 10s trop court)
      MIN_FILL_TIME_MS:     2500,    // < 2,5s = probablement un bot
      MAX_FILES:            10,
      MAX_FILE_SIZE:        10 * 1024 * 1024,
      STORAGE_KEY:          'phenixpc_devis_draft_v2',
      QUEUE_KEY:            'phenixpc_devis_queue_v2'
    };

    /* =========================================================
       HELPERS
       ========================================================= */
    var $  = function(s){ return document.querySelector(s); };
    var $$ = function(s){ return Array.prototype.slice.call(document.querySelectorAll(s)); };

    // Wrapper localStorage sécurisé - fix Opera privé / VPN Opera GX
    var storage = {
      get: function(k){
        try { return localStorage.getItem(k); }
        catch(e){ console.warn('[storage] get failed:', e); return null; }
      },
      set: function(k, v){
        try { localStorage.setItem(k, v); return true; }
        catch(e){ console.warn('[storage] set failed:', e); return false; }
      },
      remove: function(k){
        try { localStorage.removeItem(k); }
        catch(e){ console.warn('[storage] remove failed:', e); }
      }
    };

    var toasts = $('#toasts');
    function toast(msg, type){
      if (!toasts) return;
      var el = document.createElement('div');
      el.className = 'toast' + (type ? ' ' + type : '');
      el.textContent = msg;
      toasts.appendChild(el);
      setTimeout(function(){ el.style.opacity='0'; el.style.transform='translateY(6px)'; }, 4500);
      setTimeout(function(){ if(el.parentNode) el.parentNode.removeChild(el); }, 5000);
    }

    function encodeICS(s){
      return String(s).replace(/,/g,'\\,').replace(/;/g,'\\;').replace(/\n/g,'\\n');
    }

    // Debounce - évite d'appeler saveDraft à chaque frappe
    function debounce(fn, wait){
      var t;
      return function(){
        var ctx = this, args = arguments;
        clearTimeout(t);
        t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
      };
    }

    /* =========================================================
       ÉTAT DU FORMULAIRE
       ========================================================= */
    var step = 1;
    var maxStep = 4;
    var panels = $$('.panel');
    var stepEls = $$('.step');

    // Fichiers stockés en mémoire (pas seulement dans le DOM) → envoi possible
    var uploadedFiles = [];

    // Timestamp de première interaction utilisateur pour l'anti-bot
    var formOpenedAt = Date.now();
    var userInteracted = false;
    document.addEventListener('mousemove', function(){ userInteracted = true; }, { once:true, passive:true });
    document.addEventListener('keydown',   function(){ userInteracted = true; }, { once:true });
    document.addEventListener('touchstart',function(){ userInteracted = true; }, { once:true, passive:true });

    // Verrou anti double-envoi
    var isSubmitting = false;

    /* =========================================================
       NAVIGATION ÉTAPES
       ========================================================= */
    function showStep(n){
      step = Math.max(1, Math.min(maxStep, n));
      panels.forEach(function(p){
        p.classList.toggle('active', parseInt(p.dataset.step,10) === step);
      });
      stepEls.forEach(function(s,i){ s.classList.toggle('active', i+1 === step); });
      updateProgress();
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_){ window.scrollTo(0,0); }
    }

    var requiredFields = ['#first_name','#last_name','#phone','#email','#city','#budget','#pc_description'];
    function computeProgress(){
      var filled = 0;
      requiredFields.forEach(function(sel){
        var el = $(sel);
        if (el && String(el.value||'').trim().length > 0) filled++;
      });
      return Math.round((filled / requiredFields.length) * 100);
    }
    function updateProgress(){
      var pct = computeProgress();
      $('#progressBar').style.width = pct + '%';
      $('#progressLabel').textContent = pct + '% complété';
      var statusEl = $('#buildLogStatus');
      if (pct >= 100){
        statusEl.textContent = '✓ CONFIGURATION PRÊTE';
        statusEl.classList.add('ready');
      } else {
        statusEl.textContent = 'EN COURS DE CONFIGURATION...';
        statusEl.classList.remove('ready');
      }
    }

    /* =========================================================
       VALIDATION
       ========================================================= */
    function setInvalid(el, isInvalid, message){
      var wrap = el.closest('.control');
      if (!wrap) return !isInvalid;
      if (isInvalid){
        wrap.classList.add('invalid');
        var err = wrap.querySelector('.error');
        if (err && message) err.textContent = message;
        return false;
      } else {
        wrap.classList.remove('invalid');
        return true;
      }
    }

    function validateStep(n){
      var ok = true;
      if (n === 1){
        ok = setInvalid($('#first_name'), !$('#first_name').value.trim(), '// Veuillez saisir votre prénom.') && ok;
        ok = setInvalid($('#last_name'),  !$('#last_name').value.trim(),  '// Veuillez saisir votre nom.') && ok;
        ok = setInvalid($('#phone'),
             !/^(\+?\d{1,3}|0)[\s.\-]?[\d\s.\-]{8,}$/.test($('#phone').value.trim()),
             '// Téléphone invalide.') && ok;
        ok = setInvalid($('#email'),
             !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($('#email').value.trim()),
             '// Adresse e-mail invalide.') && ok;
        ok = setInvalid($('#city'), !$('#city').value.trim(), '// Ville requise.') && ok;
        var budgetVal = parseInt($('#budget').value, 10);
        ok = setInvalid($('#budget'), !(budgetVal >= 600), '// Budget requis (min 600 €).') && ok;

        if ($('#client_type').value === 'pro'){
          ok = setInvalid($('#company_name'), !$('#company_name').value.trim(),
                          '// Veuillez indiquer le nom de votre société.') && ok;
          var siretRaw = $('#company_siret').value.replace(/[\s.\-]/g,'');
          ok = setInvalid($('#company_siret'), !/^\d{14}$/.test(siretRaw),
                          '// SIRET invalide (14 chiffres).') && ok;
          ok = setInvalid($('#company_address'), !$('#company_address').value.trim(),
                          '// Veuillez indiquer votre adresse de facturation.') && ok;
        }
      }
      if (n === 2){
        ok = setInvalid($('#pc_description'),
             $('#pc_description').value.trim().length < 20,
             '// Merci de détailler (min. 20 caractères).') && ok;
      }
      if (n === 4){
        // Anti-spam multi-couches
        var hp = $('#phenix_website_url').value.trim();
        var elapsed = Date.now() - formOpenedAt;
        if (hp.length > 0){
          console.warn('[anti-spam] honeypot rempli:', hp);
          toast('Échec anti-spam. Veuillez recharger la page.', 'error');
          ok = false;
        } else if (elapsed < CONFIG.MIN_FILL_TIME_MS){
          toast('Merci de prendre un instant pour vérifier vos informations.', 'warn');
          ok = false;
        } else if (!userInteracted){
          // Aucune interaction souris/clavier/touch → très probablement un bot
          toast('Interaction utilisateur non détectée.', 'error');
          ok = false;
        }
      }
      return ok;
    }

    /* =========================================================
       COMPTEUR DESCRIPTION
       ========================================================= */
    var descEl = $('#pc_description');
    descEl.addEventListener('input', function(e){
      var len = e.target.value.length;
      $('#descCounter').textContent = len + ' / 2000';
    });

    /* =========================================================
       CHIPS (usage & résolution)
       ========================================================= */
    $$('.chips').forEach(function(group){
      var targetId = group.dataset.target;
      if (!targetId) return;
      var textarea = $('#' + targetId);
      if (!textarea) return;

      group.addEventListener('click', function(e){
        var chip = e.target.closest('.chip'); if (!chip) return;
        chip.classList.toggle('active');
        var txt = chip.textContent.trim();
        var present = textarea.value.indexOf(txt) !== -1;

        if (!present && chip.classList.contains('active')){
          textarea.value = (textarea.value + (textarea.value ? ' | ' : '') + txt).trim();
        } else if (present && !chip.classList.contains('active')){
          // Retire "txt" et le séparateur adjacent proprement
          var safe = txt.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          textarea.value = textarea.value
            .replace(new RegExp('\\s*\\|\\s*' + safe + '(?=\\s*\\||$)', 'g'), '')
            .replace(new RegExp('^' + safe + '\\s*\\|?\\s*'), '')
            .replace(new RegExp('\\s*\\|?\\s*' + safe + '$'), '')
            .trim();
        }
        textarea.dispatchEvent(new Event('input', { bubbles:true }));
      });
    });

    /* =========================================================
       TYPE DE CLIENT
       ========================================================= */
    var clientTypeChips = $('#clientTypeChips');
    var clientTypeInput = $('#client_type');
    var proFields = $('#proFields');

    clientTypeChips.addEventListener('click', function(e){
      var chip = e.target.closest('.chip'); if (!chip) return;
      clientTypeChips.querySelectorAll('.chip').forEach(function(c){ c.classList.remove('active'); });
      chip.classList.add('active');

      var type = chip.dataset.type || 'particulier';
      clientTypeInput.value = type;
      var isPro = (type === 'pro');
      proFields.style.display = isPro ? 'block' : 'none';

      if (!isPro){
        $('#company_name').value = '';
        $('#company_siret').value = '';
        $('#company_vat').value = '';
        $('#company_address').value = '';
        proFields.querySelectorAll('.control').forEach(function(c){ c.classList.remove('invalid'); });
      }
      updateProgress();
      updateBuildLog();
    });

    /* =========================================================
       BUDGET (range <-> number sync)
       ========================================================= */
    var r = $('#budget_range'), nInput = $('#budget');
    r.addEventListener('input', function(){
      nInput.value = r.value; updateProgress(); updateBuildLog();
    });
    nInput.addEventListener('input', function(){
      var v = parseInt(nInput.value || 0, 10);
      if (isNaN(v)) v = 600;
      v = Math.max(600, Math.min(137000, v));
      // Ne pas écraser pendant que l'utilisateur tape (permet la saisie multi-chiffres)
      if (v !== parseInt(nInput.value,10) && document.activeElement !== nInput){
        nInput.value = v;
      }
      r.value = v;
      updateProgress(); updateBuildLog();
    });

    /* =========================================================
       UPLOAD FICHIERS
       ========================================================= */
    var zone = $('#uploadZone');
    var inputFiles = $('#attachments');
    var previews = $('#previews');
    var fileInfo = $('#fileInfo');

    function refreshFileInfo(){
      fileInfo.textContent = uploadedFiles.length
        ? uploadedFiles.length + ' fichier(s) sélectionné(s). Taille max 10 Mo – jusqu\'à 10 fichiers.'
        : 'Taille max conseillée : 10 Mo par fichier – 10 fichiers.';
    }

    function addFiles(fileList){
      var files = Array.prototype.slice.call(fileList);
      if (uploadedFiles.length + files.length > CONFIG.MAX_FILES){
        toast('Nombre maximum de fichiers atteint (' + CONFIG.MAX_FILES + ').', 'warn');
        files = files.slice(0, CONFIG.MAX_FILES - uploadedFiles.length);
      }
      files.forEach(function(file){
        if (file.size > CONFIG.MAX_FILE_SIZE){
          toast('Fichier > 10 Mo ignoré : ' + file.name, 'warn');
          return;
        }
        uploadedFiles.push(file);

        var card = document.createElement('div'); card.className = 'preview';
        var close = document.createElement('div'); close.className = 'x'; close.textContent = '×';
        close.setAttribute('role','button');
        close.setAttribute('aria-label','Retirer ' + file.name);

        var fileRef = file; // closure
        close.addEventListener('click', function(){
          var idx = uploadedFiles.indexOf(fileRef);
          if (idx !== -1) uploadedFiles.splice(idx, 1);
          if (card._objUrl) { try { URL.revokeObjectURL(card._objUrl); } catch(_){} }
          if (card.parentNode) card.parentNode.removeChild(card);
          refreshFileInfo();
          updateBuildLog();
        });

        if (file.type.indexOf('image/') === 0){
          var img = document.createElement('img');
          try {
            var url = URL.createObjectURL(file);
            card._objUrl = url;      // permet de révoquer plus tard (fix fuite mémoire Opera)
            img.src = url;
          } catch(e){
            img.alt = file.name;
          }
          card.appendChild(img);
        } else {
          var span = document.createElement('div');
          span.className = 'doc';
          span.textContent = file.name;
          card.appendChild(span);
        }
        card.appendChild(close);
        previews.appendChild(card);
      });
      refreshFileInfo();
      updateBuildLog();
      // Reset input pour permettre de re-sélectionner le même fichier après suppression
      inputFiles.value = '';
    }

    inputFiles.addEventListener('change', function(e){ addFiles(e.target.files); });

    ['dragenter','dragover'].forEach(function(evt){
      zone.addEventListener(evt, function(e){ e.preventDefault(); e.stopPropagation(); zone.classList.add('drag'); });
    });
    ['dragleave','drop'].forEach(function(evt){
      zone.addEventListener(evt, function(e){ e.preventDefault(); e.stopPropagation(); zone.classList.remove('drag'); });
    });
    zone.addEventListener('drop', function(e){
      var dt = e.dataTransfer;
      if (dt && dt.files && dt.files.length) addFiles(dt.files);
    });

    /* =========================================================
       BROUILLON (localStorage sécurisé)
       ========================================================= */
    function getFormData(){
      return {
        first_name:      $('#first_name').value,
        last_name:       $('#last_name').value,
        phone:           $('#phone').value,
        email:           $('#email').value,
        city:            $('#city').value,
        budget:          $('#budget').value,
        pc_description:  $('#pc_description').value,
        assistance:      $('#assistance').checked,
        client_type:     $('#client_type').value || 'particulier',
        company_name:    $('#company_name').value,
        company_siret:   $('#company_siret').value,
        company_vat:     $('#company_vat').value,
        company_address: $('#company_address').value
      };
    }

    function setFormData(d){
      if (!d) return;
      $('#first_name').value      = d.first_name || '';
      $('#last_name').value       = d.last_name  || '';
      $('#phone').value           = d.phone      || '';
      $('#email').value           = d.email      || '';
      $('#city').value            = d.city       || '';
      $('#budget').value          = d.budget     || '1500';
      $('#budget_range').value    = d.budget     || '1500';
      $('#pc_description').value  = d.pc_description || '';
      $('#assistance').checked    = !!d.assistance;
      $('#client_type').value     = d.client_type || 'particulier';
      $('#company_name').value    = d.company_name    || '';
      $('#company_siret').value   = d.company_siret   || '';
      $('#company_vat').value     = d.company_vat     || '';
      $('#company_address').value = d.company_address || '';

      if ($('#client_type').value === 'pro'){
        proFields.style.display = 'block';
        clientTypeChips.querySelectorAll('.chip').forEach(function(c){
          c.classList.toggle('active', c.dataset.type === 'pro');
        });
      }
      updateProgress();
      $('#pc_description').dispatchEvent(new Event('input'));
      updateBuildLog();
    }

    var saveDraft = debounce(function(){
      storage.set(CONFIG.STORAGE_KEY, JSON.stringify(getFormData()));
    }, 400);

    function loadDraft(){
      var raw = storage.get(CONFIG.STORAGE_KEY);
      if (!raw) return;
      try {
        setFormData(JSON.parse(raw));
        toast('Brouillon restauré.');
      } catch(e){ console.warn('[draft] parse failed', e); }
    }
    function clearDraft(){
      storage.remove(CONFIG.STORAGE_KEY);
      toast('Brouillon effacé.');
    }
    document.addEventListener('input', saveDraft);
    $('#clearDraft').addEventListener('click', clearDraft);

    /* =========================================================
       BUILD LOG (panneau droit)
       ========================================================= */
    function setLg(id, value, fallback){
      var el = document.getElementById(id); if (!el) return;
      if (value && String(value).trim()){
        el.textContent = value;
        el.classList.remove('empty'); el.classList.add('fill');
      } else {
        el.textContent = fallback || '—';
        el.classList.add('empty'); el.classList.remove('fill');
      }
    }
    function updateBuildLog(){
      var d = getFormData();
      setLg('lg_type', d.client_type === 'pro' ? (d.company_name || 'Professionnel') : 'Particulier');
      setLg('lg_name', (d.first_name + ' ' + d.last_name).trim());
      setLg('lg_phone', d.phone);
      setLg('lg_email', d.email);
      setLg('lg_city',  d.city);
      setLg('lg_budget', d.budget ? d.budget + ' €' : '');
      var usage = d.pc_description
        ? d.pc_description.split('|').map(function(s){ return s.trim(); })
            .filter(function(s){ return s && s.length < 30; }).slice(0,4).join(', ')
        : '';
      setLg('lg_usage', usage);
      setLg('lg_assist', d.assistance ? 'Oui' : 'Non');

      var filesEl = document.getElementById('lg_files');
      filesEl.textContent = uploadedFiles.length;
      filesEl.classList.toggle('fill',  uploadedFiles.length > 0);
      filesEl.classList.toggle('empty', uploadedFiles.length === 0);

      var descLg = document.getElementById('lg_desc');
      if (d.pc_description && d.pc_description.trim()){
        var t = d.pc_description.trim().slice(0, 240) + (d.pc_description.length > 240 ? '…' : '');
        descLg.innerHTML = t.replace(/</g,'&lt;').replace(/>/g,'&gt;') + '<span class="buildlog-cursor"></span>';
        descLg.style.color = '#fff';
      } else {
        descLg.innerHTML = 'en attente de description<span class="buildlog-cursor"></span>';
        descLg.style.color = 'var(--muted2)';
      }
    }
    document.addEventListener('input', updateBuildLog);

    /* =========================================================
       RÉSUMÉ / EXPORTS
       ========================================================= */
    function buildSummary(){
      var d = getFormData();
      var typeLabel = d.client_type === 'pro' ? 'Professionnel' : 'Particulier';
      var companyBlock = '';
      if (d.client_type === 'pro'){
        companyBlock =
          '\nENTREPRISE :' +
          '\nRaison sociale : ' + (d.company_name || '-') +
          '\nSIRET : ' + (d.company_siret || '-') +
          '\nTVA intracom : ' + (d.company_vat || '-') +
          '\nAdresse de facturation :\n' + (d.company_address || '-') + '\n';
      }
      return '📝 DEMANDE DE DEVIS – PhenixPC' +
             '\n--------------------------------' +
             '\nNom : ' + d.first_name + ' ' + d.last_name +
             '\nType de client : ' + typeLabel +
             '\nTéléphone : ' + d.phone +
             '\nEmail : ' + d.email +
             '\nVille : ' + d.city +
             '\nBudget : ' + d.budget + ' €' +
             '\nAssistance : ' + (d.assistance ? 'Oui' : 'Non') +
             '\n' + companyBlock +
             '\nDESCRIPTION :\n' + d.pc_description +
             (uploadedFiles.length
                ? '\n\nPIÈCES JOINTES : ' + uploadedFiles.length + ' fichier(s) – '
                    + uploadedFiles.map(function(f){ return f.name; }).join(', ')
                : '');
    }

    $('#genSummary').addEventListener('click', function(){
      $('#summary').textContent = buildSummary(); toast('Résumé généré.');
    });

    function downloadBlob(blob, filename){
      var a = document.createElement('a');
      var url = URL.createObjectURL(blob);
      a.href = url; a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function(){
        if (a.parentNode) a.parentNode.removeChild(a);
        try { URL.revokeObjectURL(url); } catch(_){}
      }, 500);
    }

    $('#downloadTxt').addEventListener('click', function(){
      downloadBlob(new Blob([buildSummary()], { type:'text/plain;charset=utf-8' }), 'phenixpc_devis.txt');
    });

    $('#downloadICS').addEventListener('click', function(){
      var now = new Date();
      var dt = now.toISOString().replace(/[-:]/g,'').split('.')[0] + 'Z';
      var in30 = new Date(now.getTime() + 30*60*1000).toISOString().replace(/[-:]/g,'').split('.')[0] + 'Z';
      var ics = 'BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//PhenixPC//Devis//FR\r\n' +
                'BEGIN:VEVENT\r\nUID:' + Date.now() + '@phenixpc\r\n' +
                'DTSTAMP:' + dt + '\r\nDTSTART:' + dt + '\r\nDTEND:' + in30 + '\r\n' +
                'SUMMARY:' + encodeICS('Appel – Demande de devis PhenixPC') + '\r\n' +
                'DESCRIPTION:' + encodeICS(buildSummary()) + '\r\n' +
                'END:VEVENT\r\nEND:VCALENDAR';
      downloadBlob(new Blob([ics], { type:'text/calendar;charset=utf-8' }), 'phenixpc_devis_brouillon.ics');
    });

    function shareWhatsApp(){
      var txt = encodeURIComponent(buildSummary());
      // Opera GX bloque parfois window.open : on utilise un <a> temporaire cliqué
      var a = document.createElement('a');
      a.href = 'https://wa.me/?text=' + txt;
      a.target = '_blank'; a.rel = 'noopener';
      document.body.appendChild(a); a.click();
      setTimeout(function(){ if(a.parentNode) a.parentNode.removeChild(a); }, 100);
    }
    $('#shareWapp').addEventListener('click', shareWhatsApp);
    $('#lg_shareWapp').addEventListener('click', shareWhatsApp);

    function openCalendlyPrefill(){
      var name  = encodeURIComponent(($('#first_name').value + ' ' + $('#last_name').value).trim());
      var email = encodeURIComponent($('#email').value.trim());
      var url = CONFIG.CALENDLY_URL + '?name=' + name + '&email=' + email;
      var a = document.createElement('a');
      a.href = url; a.target = '_blank'; a.rel = 'noopener';
      document.body.appendChild(a); a.click();
      setTimeout(function(){ if(a.parentNode) a.parentNode.removeChild(a); }, 100);
    }
    $('#openCalendlyPrefill1').addEventListener('click', openCalendlyPrefill);
    $('#openCalendlyPrefill4').addEventListener('click', openCalendlyPrefill);
    $('#lg_openCalendly').addEventListener('click', openCalendlyPrefill);

    /* =========================================================
       NAVIGATION BOUTONS
       ========================================================= */
    $('#next1').addEventListener('click', function(){ if (validateStep(1)) showStep(2); });
    $('#back2').addEventListener('click', function(){ showStep(1); });
    $('#next2').addEventListener('click', function(){ if (validateStep(2)) showStep(3); });
    $('#back3').addEventListener('click', function(){ showStep(2); });
    $('#next3').addEventListener('click', function(){ showStep(4); });
    $('#back4').addEventListener('click', function(){ showStep(3); });

    /* =========================================================
       QUEUE HORS LIGNE
       ========================================================= */
    function enqueue(payload){
      try {
        var arr = JSON.parse(storage.get(CONFIG.QUEUE_KEY) || '[]');
        arr.push(payload);
        storage.set(CONFIG.QUEUE_KEY, JSON.stringify(arr));
      } catch(e){ console.warn('[queue] enqueue failed', e); }
    }

    async function flushQueue(){
      var raw = storage.get(CONFIG.QUEUE_KEY);
      if (!raw) return;
      var arr;
      try { arr = JSON.parse(raw); } catch(_) { arr = []; }
      if (!arr.length) return;
      toast('Envoi des demandes en attente (' + arr.length + ')…');
      while (arr.length){
        try {
          await sendToWeb3Forms(arr[0], null); // pas de fichiers pour la queue
          arr.shift();
          storage.set(CONFIG.QUEUE_KEY, JSON.stringify(arr));
        } catch(e){
          console.warn('[queue] flush failed', e);
          break;
        }
      }
      if (!arr.length) toast('Toutes les demandes en attente ont été envoyées.');
    }
    window.addEventListener('online', flushQueue);

    /* =========================================================
       ENVOI À WEB3FORMS (avec AbortController + pièces jointes)
       ========================================================= */
    async function sendToWeb3Forms(payload, files){
      var fd = new FormData();
      fd.append('access_key', CONFIG.WEB3FORMS_ACCESS_KEY);
      fd.append('subject', 'Nouvelle demande de devis – ' + payload.first_name + ' ' + payload.last_name);
      fd.append('from_name', 'PhenixPC – Formulaire devis');
      fd.append('replyto', payload.email); // ← permet de répondre directement au client
      fd.append('botcheck', '');           // ← honeypot Web3Forms côté serveur

      Object.keys(payload).forEach(function(k){
        if (k === 'access_key' || k === 'subject' || k === 'from_name' || k === 'replyto' || k === 'botcheck') return;
        fd.append(k, payload[k]);
      });

      // Pièces jointes (fix majeur : elles étaient ignorées avant)
      if (files && files.length){
        files.forEach(function(f, i){
          fd.append('attachment_' + (i+1), f, f.name);
        });
      }

      // AbortController : vrai timeout, annule la requête réseau
      var controller = new AbortController();
      var timeoutId = setTimeout(function(){ controller.abort(); }, CONFIG.FETCH_TIMEOUT_MS);

      var resp;
      try {
        resp = await fetch(CONFIG.WEB3FORMS_ENDPOINT, {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' },
          signal: controller.signal
        });
      } catch(err){
        clearTimeout(timeoutId);
        if (err.name === 'AbortError'){
          throw new Error('Délai d\'attente dépassé (' + (CONFIG.FETCH_TIMEOUT_MS/1000) + 's).');
        }
        throw err;
      }
      clearTimeout(timeoutId);

      var result;
      try { result = await resp.json(); }
      catch(e){ throw new Error('Réponse serveur non valide (HTTP ' + resp.status + ').'); }

      if (!resp.ok || !result.success){
        throw new Error(result.message || ('Échec serveur (HTTP ' + resp.status + ').'));
      }
      return result;
    }

    /* =========================================================
       FALLBACK MAILTO (si tout échoue)
       ========================================================= */
    function buildMailto(){
      var d = getFormData();
      var subject = encodeURIComponent('Demande de devis – ' + d.first_name + ' ' + d.last_name);
      var body    = encodeURIComponent(buildSummary());
      return 'mailto:' + CONFIG.CONTACT_EMAIL + '?subject=' + subject + '&body=' + body;
    }
    $('#mailtoFallback').addEventListener('click', function(){
      window.location.href = buildMailto();
    });

    /* =========================================================
       SOUMISSION FORMULAIRE
       ========================================================= */
    function buildPayload(){
      var isPro = $('#client_type').value === 'pro';
      return {
        first_name:      $('#first_name').value.trim(),
        last_name:       $('#last_name').value.trim(),
        phone:           $('#phone').value.trim(),
        email:           $('#email').value.trim(),
        city:            $('#city').value.trim(),
        budget:          $('#budget').value.trim(),
        pc_description: $('#pc_description').value.trim(),
        assistance:      $('#assistance').checked ? 'Oui' : 'Non',
        client_type:     $('#client_type').value,
        client_label:    isPro ? 'Client professionnel' : 'Client particulier',
        company_name:    isPro ? $('#company_name').value.trim()    : '',
        company_siret:   isPro ? $('#company_siret').value.trim()   : '',
        company_vat:     isPro ? $('#company_vat').value.trim()     : '',
        company_address: isPro ? $('#company_address').value.trim() : '',
        submitted_at:    new Date().toISOString(),
        user_agent:      (navigator.userAgent || '').slice(0, 200)
      };
    }

    var form = $('#contact-form');
    var sendBtn = $('#sendBtn');
    var sendLabel = sendBtn.querySelector('.submit-label');
    var mailtoBtn = $('#mailtoFallback');

    function setSendingState(sending){
      isSubmitting = sending;
      sendBtn.disabled = sending;
      sendBtn.classList.toggle('loading', sending);
      sendLabel.textContent = sending ? 'Envoi en cours…' : 'Envoyer la demande de devis';
    }

    form.addEventListener('submit', async function(e){
      e.preventDefault();
      if (isSubmitting) return;

      // Validation complète avant envoi
      if (!validateStep(1)){ showStep(1); toast('Vérifiez les champs marqués en rouge.', 'error'); return; }
      if (!validateStep(2)){ showStep(2); toast('Vérifiez la description de votre projet.', 'error'); return; }
      if (!validateStep(4)){ return; } // toast déjà affiché par validateStep

      setSendingState(true);
      mailtoBtn.style.display = 'none';

      var payload = buildPayload();

      try {
        await sendToWeb3Forms(payload, uploadedFiles);

        toast('✅ Votre demande a été envoyée avec succès !');
        clearDraft();

        // Reset propre
        form.reset();
        $('#budget').value = '1500';
        $('#budget_range').value = '1500';
        $('#descCounter').textContent = '0 / 2000';
        // Reset fichiers + révocation des ObjectURL (fix fuite mémoire Opera)
        uploadedFiles = [];
        $$('#previews .preview').forEach(function(c){
          if (c._objUrl){ try { URL.revokeObjectURL(c._objUrl); } catch(_){} }
        });
        previews.innerHTML = '';
        refreshFileInfo();
        // Reset chips actives
        $$('.chips .chip.active').forEach(function(c){
          if (c.dataset.type !== 'particulier') c.classList.remove('active');
        });
        showStep(1);
        updateProgress();
        updateBuildLog();

        // Purge la queue si des envois étaient en attente
        try { await flushQueue(); } catch(_){}
      } catch(err){
        console.error('[submit] erreur:', err);
        // Sauvegarde locale + proposition mailto
        enqueue(payload);
        toast('⚠️ Envoi impossible : ' + (err.message || 'erreur inconnue') +
              ' — votre demande est enregistrée. Vous pouvez aussi l\'envoyer via votre messagerie.', 'error');
        mailtoBtn.style.display = 'block';
      } finally {
        setSendingState(false);
      }
    });

    /* =========================================================
       TOGGLE EFFETS
       ========================================================= */
    var fxToggle = $('#fxToggle');
    fxToggle.addEventListener('click', function(){
      document.body.classList.toggle('fx-off');
      var pressed = fxToggle.getAttribute('aria-pressed') === 'true';
      fxToggle.setAttribute('aria-pressed', String(!pressed));
    });

    /* =========================================================
       INITIALISATION
       ========================================================= */
    loadDraft();

    /* =========================================================
       PRÉ-REMPLISSAGE CLIENT SHOPIFY (si connecté)
       ========================================================= */
    if (window.PHENIX_CUSTOMER){
      var c = window.PHENIX_CUSTOMER;
      // On ne remplit que si le champ est vide (préserve le brouillon en cours)
      function fillIfEmpty(sel, val){
        var el = $(sel);
        if (el && !el.value && val){ el.value = val; }
      }
      fillIfEmpty('#first_name', c.first_name);
      fillIfEmpty('#last_name',  c.last_name);
      fillIfEmpty('#email',      c.email);
      fillIfEmpty('#phone',      c.phone);
      updateProgress();
      updateBuildLog();
    }

    $('#pc_description').dispatchEvent(new Event('input'));
    updateProgress();
    updateBuildLog();

    // Purge la queue au chargement si connexion OK
    if (navigator.onLine) { setTimeout(flushQueue, 1500); }

    // Empêche la perte accidentelle de saisie
    window.addEventListener('beforeunload', function(e){
      if (isSubmitting) return;
      var d = getFormData();
      var hasContent = (d.first_name || d.last_name || d.email || d.pc_description || '').length > 30;
      if (hasContent && computeProgress() < 100){
        e.preventDefault();
        e.returnValue = '';
      }
    });

  
})();